import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getRecipes } from '../services/recipe';
import { RecipeList } from '../components/recipe/RecipeList';
import { useSearchParams } from 'react-router-dom';

export default function HomePage() {
  const [searchParams] = useSearchParams();
  const category = searchParams.get('category');
  const searchTerm = searchParams.get('search') || '';
  const selectedTag = searchParams.get('tag') || '';

  const { data: recipes = [], isLoading } = useQuery({
    queryKey: ['recipes', category, searchTerm, selectedTag],
    queryFn: () => getRecipes(category || undefined, searchTerm, selectedTag),
  });

  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-gray-900">
        {searchTerm || selectedTag ? 
          `Search results for ${[
            searchTerm && `"${searchTerm}"`,
            selectedTag && `tag: ${selectedTag}`
          ].filter(Boolean).join(' and ')}` 
          : category || 'All Recipes'}
      </h1>
      <RecipeList recipes={recipes || []} isLoading={isLoading} />
    </div>
  );
}